import React from 'react'
import VideoFlexGrid from './Videogrid'
import Reveal from './Reveal'
import Atmosphere from './Atmosphere'

function Creation() {
  const mediaItems = [
    { url: '/souslesdraps.png', type: 'link', title: 'LMS accessible & contenus multimédia 2D/3D — Sous Les DRAPS' },
    { url: 'h7-niOvadgg', type: 'video', title: 'Vidéo publicitaire en Motion Design — AXA' },
    { url: 'AJuYVlcHjs4', type: 'video', title: "L'accessibilité des meetings politiques — CNCPH" },
    { url: '/livret.png', type: 'image', title: "Livret d'accueil accessible pour les patients — Hôpital FOCH" },
    { url: 'dBiCQjq1ax0', type: 'video', title: 'Carte de vœux animée' },
    { url: 'sgU8XHr5u58', type: 'video', title: 'Animation pour les Jeux Paralympiques 2024' },
    { url: 'oQSq8_KYwRU', type: 'video', title: 'Carte de visite en réalité augmentée — Crédit Agricole Immobilier' },
    { url: '3MRoNeqFCC0', type: 'video', title: 'Création 2D & 3D — apprenants de la formation C.I.A.R.A' },
    { url: 's6OdIzlvZBI', type: 'video', title: 'Motion design — apprenants de la formation C.I.A.R.A' },
    { url: 'pEU2_cJfZgk', type: 'video', title: 'Modélisation 3D pour jeux — apprenants formation CIARA' },
  ]

  return (
    <section id="Creation" className="relative overflow-hidden py-24 lg:py-32 scroll-mt-24">
      <Atmosphere variant="default" />
      <div className="container-pdv relative z-10">
        <Reveal className="max-w-2xl mb-14">
          <span className="eyebrow">Portfolio</span>
          <h2 className="mt-5 font-display font-extrabold leading-[1.05] text-[clamp(2rem,4.4vw,3.4rem)]">
            Nos <span className="text-gradient">créations</span>
          </h2>
          <p className="mt-5 text-lg text-[#b6a9d8]">
            Films d'animation, jeux, motion design, réalité augmentée et supports accessibles —
            réalisés pour des marques et institutions de premier plan.
          </p>
        </Reveal>

        <VideoFlexGrid mediaItems={mediaItems} />
      </div>
    </section>
  )
}

export default Creation
